import { makeStyles } from "@fluentui/react-components";
import { primer } from "./primerDarkTheme";

export const useStatsRowStyles = makeStyles({
    row: { display: "flex", gap: "14px", flexWrap: "wrap" as const, flexShrink: 0 },
    card: {
        flex: "1 1 0",
        minWidth: "110px",
        padding: "14px 16px",
        borderRadius: "6px",
        border: `1px solid ${primer.border}`,
        backgroundColor: primer.surface,
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        overflow: "hidden",
    },
    labelRow: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        overflow: "hidden",
    },
    dot: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        flexShrink: 0,
    },
    label: { fontSize: "12px", color: primer.fgMuted, fontWeight: 500, whiteSpace: "nowrap" as const },
    value: { fontSize: "24px", fontWeight: 700, color: primer.fg },
    description: { fontSize: "11px", color: primer.fgMuted, overflow: "hidden", textOverflow: "ellipsis" as const },
    trend: { fontSize: "11px", color: primer.fgSubtle },
});
